import { render, staticRenderFns } from "./BindHisCard.vue?vue&type=template&id=72bad4aa&scoped=true"
import script from "./BindHisCard.vue?vue&type=script&lang=js"
export * from "./BindHisCard.vue?vue&type=script&lang=js"
import style0 from "./BindHisCard.vue?vue&type=style&index=0&id=72bad4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bad4aa",
  null
  
)

export default component.exports